export const NATIVE_TOKEN = '0x0000000000000000000000000000000000000000'

